import {Component, OnInit, Output, EventEmitter} from '@angular/core'
import moment from 'moment'

@Component({
  selector: 'app-terminal-events-date-jumper',
  templateUrl: './terminal-events-date-jumper.component.html',
  styleUrls: ['./terminal-events-date-jumper.component.scss'],
  standalone: false,
})
export class TerminalEventsDateJumperComponent implements OnInit {
  @Output() changed = new EventEmitter<{timestamp: number}>()

  public date: Date
  public time: Date
  public datetime: Date

  constructor() {}

  ngOnInit() {
    this.date = moment().endOf('day').toDate()
    this.time = moment().endOf('day').toDate()
  }

  emitDatetime() {
    // time and date are different models
    const time = moment(this.time).diff(moment().startOf('day'))
    this.datetime = moment(this.date).startOf('day').clone().add(time).toDate()
    this.changed.emit({timestamp: this.datetime.valueOf()})
  }
}
